const getFilterValuesForContacts = (values: string[] | boolean[]): string[] => {
  return values.map((filterValue) => {
    return String(filterValue);
  }) as string[];
};

export default getFilterValuesForContacts;
